import styled from 'styled-components';

export const HelpText = styled.div`
  font-size: 10px;
  padding-left: 4px;
  padding-top: 2px;
  color: gray;
`;
